import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
// import { Subject } from 'rxjs';
import { PlayerListColumn } from './player-list-column';
import * as fs from 'file-saver';
import { Column, Workbook } from 'exceljs';

@Component({
  selector: 'app-player-list',
  templateUrl: './player-list.component.html',
  styleUrls: ['./player-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PlayerListComponent {
  @Input()
  data = [];

  @Input()
  columns: PlayerListColumn[] = [];

  @Input()
  name = '';

  @Input()
  totalPlayers = 0;

  @Input()
  showDownloadButton = false;

  @Input()
  worksheetColumns: Column[] = [];

  @Input()
  showIndexColumn = true;

  downloadReport(): void {
    const workbook = new Workbook();
    const worksheet = workbook.addWorksheet(this.name);
    worksheet.columns = this.worksheetColumns;
    worksheet.addRows(this.data);
    workbook.xlsx.writeBuffer().then((data) => {
      const blob = new Blob([data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });
      fs.saveAs(blob, this.name + '.xlsx');
    });
  }
}
